export default __webpack_public_path__ + "static/media/annotation_icon.13b6919c.svg";